import React, { useState } from 'react';
import ConsoleHelper from '../functions/consoleHelper';

function getStorageValue<T>(key: string, defaultValue: T): T {
  if (typeof window !== 'undefined' && window.localStorage) {
    const saved = localStorage.getItem(key);
    if (saved !== null) {
      try {
        return JSON.parse(saved) as T;
      } catch (error) {
        ConsoleHelper.error(`Error parsing localStorage key "${key}":`, error);
      }
    }
  }
  return defaultValue;
}

export const useLocalStorage = <T>(localStorageKey: string, defaultValue: T): [T, React.Dispatch<React.SetStateAction<T>>] => {
  const [value, setValue] = useState<T>(() => {
    return getStorageValue<T>(localStorageKey, defaultValue);
  });

  React.useEffect(() => {
    if (value !== getStorageValue<T>(localStorageKey, defaultValue)) {
      localStorage.setItem(localStorageKey, JSON.stringify(value));
    }
  }, [defaultValue, localStorageKey, value]);

  return [value, setValue];
};
